import React from 'react';

import {
  Text as MantineText,
  TextProps as MantineTextProps,
  createPolymorphicComponent,
} from '@mantine/core';

import classes from './text.module.css';

type TextTypes = 'body' | 'sub' | 'overline' | 'caption' | 'label';

export const defaultTextProps = MantineText.extend({
  classNames: {
    root: classes.root,
  },
});

interface TextProps extends Partial<MantineTextProps> {
  type?: TextTypes;
  onClick?: (any: unknown) => unknown;
}

const _Text = React.forwardRef<HTMLDivElement, TextProps>(({ type, variant, ...props }, ref) => (
  <MantineText variant={variant ?? type} ref={ref} {...props} />
));
_Text.displayName = 'Text';

const Text = createPolymorphicComponent<'div', TextProps>(_Text);
export { Text };
export type { TextProps };
